module.exports = __webpack_public_path__ + "static/media/plus.352dfa81.svg";